import { logoUrl } from "@/api/image/api";
import useDarkModeState from "@/hooks/useDarkModeState";

export default function LogoTitle({
  className = "",
  isTop = false,
}: {
  className?: string;
  /** サイトトップ（常に暗い背景画像の上）では、テーマによらず暗背景用のロゴを出す */
  isTop?: boolean;
}) {
  const isDarkTheme = useDarkModeState();
  const isDark = isTop || isDarkTheme;

  return (
    <a
      href={route("top")}
      className={
        "flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0 " +
        className
      }
    >
      <img
        className="w-full h-[60px] "
        src={logoUrl(isDark)}
        alt={import.meta.env.VITE_APP_NAME || "lusys"}
      />
    </a>
  );
}
